import {
    Directive,
    Input,
    ElementRef,
    AfterContentInit
} from '@angular/core';

@Directive({
  standalone: false,
    selector: '[appAutoFocus]'
})
export class AutoFocusDirective implements AfterContentInit {
    @Input() public autoFocus;

    constructor(private el: ElementRef) {}

    ngAfterContentInit(): void {
        if (this.autoFocus === 'true') {
            setTimeout(() => {
                this.el.nativeElement.focus();
            }, 500);
        }
    }
}
